import { render, staticRenderFns } from "./InfiniteScroller.vue?vue&type=template&id=8d38f322&"
import script from "./InfiniteScroller.vue?vue&type=script&lang=ts&"
export * from "./InfiniteScroller.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports